<template>
  <v-cotainer fluid grid-list-md fill-height >
    <v-layout row wrap> 
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Product Set Management
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn 
            outlined 
            @click="productSetDialog = true,selectedProductSet = null">
            <v-icon left color="teal">add</v-icon>
              New Product Set 
          </v-btn>
          <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link> -->
        </v-toolbar>

        <v-data-table
          :headers="productSetHeader"
          :items="productSetsByBrand"      
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
            </td>
            <td>
              <b>{{props.item['name']}}</b>
            </td>
            <td>
              <b class="font-weight-bold primary--text">{{getTotal(props.item) || 0 | amount}}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editProductSet(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteProductSet(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    
    <!-- Start Product Set Dialog -->
    <v-dialog v-model="productSetDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Create Product Set</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                    <v-text-field label="Product Set Name" v-model="productSetName" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-combobox
                  v-model="productsToProductSet"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  @change="addToBucket()"
                  label="Product"
                  multiple
                ></v-combobox>
              </v-flex>
              <v-flex xs12 sm12 md12>
                  <v-layout wrap>
                    <template v-for="item in items">
                    <v-flex :key="item.productId" xs3 sm3 md3>
                      {{item.productName}}
                    </v-flex>
                    <v-flex :key="item.productName" xs3 sm3 md3>
                       <v-text-field type="number" v-model.number="item.quantity" label="Quantity">
                       </v-text-field>
                    </v-flex>
                     <v-flex xs3 sm3 md3 :key="item.productId+'a'" >
                      <v-select
                        dense
                        item-text="text"
                        item-value="value"
                        :items="units"
                        label="Select unit"
                        v-model="item.unit"
                      ></v-select>
                    </v-flex>
                     <v-flex :key="item.productName+'RATE'" xs3 sm3 md3>
                       <v-text-field type="number" v-model.number="item.rate" label="Rate">
                       </v-text-field>
                    </v-flex>
                    </template>
                  </v-layout>
               </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="productSetDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="!items.length"
                v-if="selectedProductSet && selectedProductSet['.key']"
                @click="updateProductSet()"
                flat
              >Update</v-btn>
              <v-btn
                color="blue darken-1"
                v-else
                :disabled="!items.length"
                @click="addProductSet()"
                flat
              >Create</v-btn>
               
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="viewProductSetDialog" width="800" v-if="selectedProductSet && selectedProductSet['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>ProductSet details: - {{selectedProductSet['.key']}}</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="productInvoiceHeader"
              :items="selectedProductSet.items"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <b>{{ props.item['productName']}}</b>
                </td>
                <td>
                  <b>{{ props.item['quantity']}}</b>
                </td>
                <td>
                  <b>{{ props.item.unit}}</b>
                </td>
                <td>
                  <b><v-text-field  type="number" v-model.number="props.item.rate" label="Product Rate"></v-text-field></b>
                </td>
                <td>
                  <v-btn
                    color="primary"
                    text
                    @click="fetchLatestRate(props.item)"
                    >Fetch Rate</v-btn>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="fetchLatestRateBulk()"
              >Fetch Latest Rates</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="viewProductSetDialog = false">Back</v-btn>
            <v-btn color="primary" text @click="saveUpdatedSet()">Update </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      productsToProductSet : [],
      productSetName : null,
      items:[],
      productSetDialog: false,
      selectedProductSet : null,
      viewProductSetDialog : false,
      productSetHeader: [
        { text: "View", value: "quantity" },
        { text: "Product Set Name", value: "deposit - ID" }, 
        { text: "Total Amount", value: "name" }, 
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "edit" },
      ],
      productInvoiceHeader: [
        { text: "Name", value: "Name" },
        { text: "Quantity", value: "Taxable" },
        { text: "unit", value: "HSN" },
        { text: "Rate", value: "rate" },
        { text: "Fetch", value : "fetch"}
      ]
     
    };
  },
  created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("productSets", this.$root.$firebaseRefs.productSets.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('productById', this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand))
    if (this.$route.params.isNew) { 
      this.productSetDialog = true
    }
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand",'finYear']),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      return this.products.filter(
        item => {
          return (item["brand"] === this.selectedBrand && 
          (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
        }
      );
    },
    productSetsByBrand(){
      return this.productSets.filter(
        item => {
          return (item["brand"] === this.selectedBrand && 
          (item.date ? (item.date >= this.finYear.start) && (item.date <= this.finYear.end) : true))
        }
      );
    },
  },
  methods: {
    openProd(item){
      this.selectedProductSet =item; 
      this.viewProductSetDialog = true;
    },
    getTotal(item){
      let total = 0;
      item.items.map((i)=>{
        total += Number.parseFloat((Number.parseFloat(i.rate)) * (Number.parseFloat(i.quantity)))
      })
      return total;
    },
    fetchLatestRate(item) {
      let prod = this.products.find((item1) => item1[".key"] == item.productId);
      item.rate = Number.parseFloat((prod && prod.sellingPrice) || 0);
    },
    fetchLatestRateBulk(){
      this.selectedProductSet.items.map((item)=>this.fetchLatestRate(item));
    },
    addToBucket(){
      this.items = [];
      this.productsToProductSet.map((prod)=>{
        this.items.push({
          productName:prod.name,
          productId:prod['.key'],
          quantity:1,
          unit: prod.unit,
          rate : this.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0
        });
      })
    },
    addProductSet(){
      let productSetObj = {
        brand: this.selectedBrand,
        items: this.items,
        name: this.productSetName
      }
      this.$root.$firebaseRefs.productSets.push(productSetObj);
      if (this.$route.params.redirect) { 
       this.$router.push({ path: `/quick-invoice` });
      } else { 
       this.productSetDialog = false;
       this.selectedBuyer = null;
       this.productSetName = null;
       this.items = [];
       this.productsToProductSet = [];
      }
    },
    deleteProductSet(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.productSets.child(productSet[".key"]).remove();
      }
    },
    editProductSet(set){
      this.selectedProductSet = set;
      this.productSetName = this.selectedProductSet.name;
      this.items = this.selectedProductSet.items;
      this.productSetDialog = true;
      this.productsToProductSet = [];
      this.items.map((item)=>{
        let prod  = this.products.find(prod => prod['.key'] == item['productId']);
        prod && this.productsToProductSet.push(prod);
      })
    },
    updateProductSet(){
      this.selectedProductSet['items'] = this.items;
      this.selectedProductSet['name'] = this.productSetName;
      this.saveUpdatedSet();
    },
    saveUpdatedSet(){
      let key = this.selectedProductSet[".key"];
        delete this.selectedProductSet[".key"];
        this.$root.$firebaseRefs.productSets.child(key).update(this.selectedProductSet, () => {
          this.selectedProductSet = null;
          this.productSetDialog = false;
          this.viewProductSetDialog = false;
        });
    },
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Settings/ProductSet/productSet.vue